import React, { FC } from 'react';
import { Container, Flex, Link } from 'roo-ui/components';
import styled from '@emotion/styled';
import { HeaderContextType, useHeaderContext } from '../../HeaderContext';
import { themeGet } from 'styled-system';

export const NavigationLinks: FC = () => {
  const { desktopLinks, onInteraction } = useHeaderContext();

  return (
    <NavigationLinksMemo
      desktopLinks={desktopLinks}
      onInteraction={onInteraction}
    />
  );
};

type MemoProps = Pick<HeaderContextType, 'desktopLinks' | 'onInteraction'>;

const NavigationLinksMemo = React.memo<MemoProps>(
  ({ desktopLinks, onInteraction }) => {
    return (
      <Flex bg="#333333">
        <Container>
          <NavList>
            {desktopLinks.map(({ trackingName, ...link }) => (
              <li key={trackingName}>
                <NavLink
                  onClick={() =>
                    onInteraction({
                      type: 'Site Navigation',
                      value: `${trackingName} Selected`,
                    })
                  }
                  {...link}
                />
              </li>
            ))}
          </NavList>
        </Container>
      </Flex>
    );
  }
);

const NavList = styled.ul`
  display: flex;
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

const NavLink = styled(Link)`
  white-space: nowrap;
  font-size: ${themeGet('fontSizes.header.base')};
  padding: ${themeGet('space.5')} ${themeGet('space.5')};
  width: 100%;
  color: ${themeGet('colors.white')};

  &:hover {
    background-color: ${themeGet('colors.white')};
    color: ${themeGet('colors.brand.primary')};
  }
`;
